import { 
  Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography 
} from "@mui/material";
import { useEffect, useState } from "react";
import { getDecryptedAccessToken, getDecryptedData } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const ProviderAvailableSchedule = ({ doctor }) => {
  const AccessToken = getDecryptedAccessToken();
  const LoginUserData = getDecryptedData();
  const providerId = doctor?.id || LoginUserData.id;

  const [scheduleData, setScheduleData] = useState([]);

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const response = await ApiServices.get(
          `/apis/default/api/clinicslots/providerAppointments/${providerId}`,
          { Authorization: `Bearer ${AccessToken}` }
        );
        console.log("API Response:", response.data);
        setScheduleData(response.data.data);
      } catch (error) {
        console.error("Error fetching schedule:", error);
      }
    };

    if (providerId) {
      fetchSchedule();
    }
  }, [providerId, AccessToken]);

  const today = new Date().toISOString().split("T")[0];

  // **Group Schedules by Date**
  const groupedSchedules = {};
  scheduleData.forEach((slot) => {
    if (!groupedSchedules[slot.date]) {
      groupedSchedules[slot.date] = { day: slot.day, slots: [] };
    }
    groupedSchedules[slot.date].slots.push(slot);
  });

  const renderScheduleTable = (schedules) => {
    if (Object.keys(schedules).length === 0) {
      return (
        <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", marginTop: 2 }}>
          <EventBusyIcon sx={{ verticalAlign: "middle", marginRight: 1 }} />
          No schedule available. Please create a schedule.
        </Typography>
      );
    }

    return Object.entries(schedules).map(([date, { day, slots }]) => {
      // **Group slots by start_time, end_time, type, and availability**
      const slotMap = new Map();

      slots.forEach((slot) => {
        const key = `${slot.start_time}-${slot.end_time}-${slot.type}-${slot.available}`;
        if (!slotMap.has(key)) {
          slotMap.set(key, { ...slot, count: 1 });
        } else {
          slotMap.get(key).count += 1;
        }
      });

      const uniqueSlots = Array.from(slotMap.values());

      return (
        <Card key={date} sx={{ marginBottom: 2, padding: 2, boxShadow: 3, borderRadius: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#028391" }}>
            <EventAvailableIcon sx={{ verticalAlign: "middle", marginRight: 1 }} />
            {day}, {date}
          </Typography>
          <TableContainer>
            <Table sx={{ minWidth: 600 }}>
              <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    <AccessTimeIcon sx={{ verticalAlign: "middle", marginRight: 1 }} /> Start Time
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>End Time</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Available</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uniqueSlots.map((slot, index) => (
                  <TableRow key={index} sx={{ "&:hover": { backgroundColor: "#f0f8ff" } }}>
                    <TableCell>{slot.start_time}</TableCell>
                    <TableCell>{slot.end_time}</TableCell>
                    <TableCell>{slot.type}</TableCell>
                    <TableCell>
                      {slot.available ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                    </TableCell>
                    <TableCell>{slot.availability_mode}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      );
    });
  };

  return (
    <div>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#388e3c" }}>
        Upcoming & Current Slots
      </Typography>
      {renderScheduleTable(
        Object.fromEntries(Object.entries(groupedSchedules).filter(([date]) => date >= today))
      )}

      {Object.entries(groupedSchedules).some(([date]) => date < today) && (
        <>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#d32f2f" }}>
            Past Slots
          </Typography>
          {renderScheduleTable(
            Object.fromEntries(Object.entries(groupedSchedules).filter(([date]) => date < today))
          )}
        </>
      )}
    </div>
  );
};

export default ProviderAvailableSchedule;
